import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/bootstrap.js'
import './plugins/firebase.js'
import './plugins/sweetalert.js'
import './plugins/scrollto.js'
import './plugins/vue2-filters.js'
import './plugins/logger.js'

Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.silent = process.env.NODE_ENV === 'production';
Vue.config.productionTip = process.env.NODE_ENV !== 'production';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
